import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import $ from 'jquery';

Component('tr-trash-items-box', {
  mixins: [eventListenerMixin],

  properties: {
    scrollLoadUrl: String,
  },

  ready() {
    if (!this.scrollLoadUrl) return;
    this.scrollLoadTrigger = this.querySelector('tr-scroll-load-trigger');
    if (!this.scrollLoadTrigger) return;

    this.listenTo(this.scrollLoadTrigger, {
      'tr-scroll-load-trigger:loading': this.loadMore.bind(this),
    });
  },

  loadMore() {
    const lastItem = this.querySelector('.day:last-of-type .trash-item:last-of-type');
    if (!lastItem) {
      this.removeScrollLoadTrigger();
    } else {
      $.ajax({
        url: this.scrollLoadUrl,
        type: 'GET',
        dataType: 'json',
        data: {
          last_trash_item_id: $('.day:last .trash-item:last').attr('id'),
        },
        success: (result) => {
          if (result.html) this.insertTrashItems($(result.html));
          if (result.is_last_page) {
            this.removeScrollLoadTrigger();
          } else {
            this.scrollLoadTrigger.loading = false;
          }
        },
      });
    }
  },

  removeScrollLoadTrigger() {
    this.scrollLoadTrigger.parentNode.removeChild(this.scrollLoadTrigger);
  },

  insertTrashItems(nodes) {
    const lastBlockInPage = $(this).find('.day').last();
    const firstBlockInResult = nodes.first();

    if (lastBlockInPage.data('date') !== firstBlockInResult.data('date')) {
      $(lastBlockInPage).after(nodes);
    } else {
      const leftNodes = nodes.slice(1);
      lastBlockInPage.find('.bd').append(firstBlockInResult.find('.bd').contents());
      $(lastBlockInPage).after(leftNodes);
    }
  },
});
